import React from 'react';
import { Outlet } from 'react-router-dom';
import { useEnrollmentAccess } from '../../hooks/access/useEnrollmentAccess';
import { useCourseId } from '../../hooks/course/useCourseId';
import AccessDenied from '../access/AccessDenied';

const LessonsRoute: React.FC = () => {
  const courseId = useCourseId() ?? '';
  const { canAccessLessons } = useEnrollmentAccess(courseId);

  if (!canAccessLessons) {
    return (
      <AccessDenied
        message="Acesso às aulas não disponível para esta matrícula"
        statusCode={403}
      />
    );
  }

  return <Outlet />;
};

export default LessonsRoute;
